import React, { ReactElement, Component, useContext, useMemo, useCallback, Fragment, useEffect, useState } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import "./left-menu.less";
import { Menu, Col, Row } from "antd";
import { left_menu_item } from "../../contexts/left-menu";
import SubMenu from "antd/lib/menu/SubMenu";
import { Link, withRouter } from "react-router-dom";
import { permissions, permission_in_roles_array, permission_in_roles_number } from "../../permissions";
import { prevent } from "../../pages/applications/applications";
import { TypeNameContext } from "../../contexts/type_name";
import { ClustersForPageContext } from "../../contexts/clusters-for-page";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { user_subscription } from "../../contexts/user-subscriptions";
import { clusters_for_page_type } from "../../contexts/clusters-for-page";
import { FlyInContext } from "../../contexts/fly-in";
import { Version } from "../../app/enum/version.enum";
import { close_loading } from '../../pages/applications/common-file/service';
import { CloseGuideContext } from '../../contexts/close-guide';
import { ShowGuideContext } from '../../contexts/show-guide';
import { useDeepCompareMemo } from 'use-deep-compare';

interface left_menu_item_global {
  key: string;
  sub?: left_menu_item[];
  i18n?: string;
}

interface link {
  [key: string]: string;
}

const service_pathname: string[] = ['applications', 'applications-detail', 'monitor/service-usage', 'instance-list', 'create-secret', 'resource/view', 'resource/service'];

const LeftMenu = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [fly_in, set_fly_in]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useContext(FlyInContext),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    clusters_for_page: clusters_for_page_type | undefined = useContext(ClustersForPageContext)[0],
    [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(TypeNameContext),
    [close_guide, set_close_guide]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(CloseGuideContext),
    set_show_guide: React.Dispatch<React.SetStateAction<boolean>> = useContext(ShowGuideContext)[1],
    [openKeys, setOpenKeys]: [string[], React.Dispatch<React.SetStateAction<any>>] = useState([]),
    [is_ssoSubscriptions, set_is_ssoSubscriptions]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    path = props.history.location.pathname.substring(1),
    global_items: left_menu_item_global[] = useMemo(
      () =>
        user_info.role
          ? [
            { key: "applications", i18n: "applications" },
            {
              key: formatMessage({ id: "platform-management" }),
              sub: [
                ...(clusters_for_page?.clusters_for_dedicate_clusters_page?.length ? [{ key: "dedicate_clusters", i18n: "clusters" }] : []),
                ...(clusters_for_page?.clusters_for_dedicate_workspaces_page?.length ? [{ key: "dedicate_workspaces", i18n: "workspaces" }] : []),
                ...(clusters_for_page?.clusters_for_dedicate_namespaces_page?.length ? [{ key: "dedicate_namespaces", i18n: "namespaces" }] : []),
                ...(clusters_for_page?.clusters_for_dedicate_namespaces_page?.length ? [{ key: "dedicate_workloads", i18n: "workloads" }] : []),
                ...(clusters_for_page?.clusters_for_shared_clusters_page?.length ? [{ key: "shared_clusters", i18n: "clusters" }] : []),
                ...(clusters_for_page?.clusters_for_shared_workspaces_page?.length ? [{ key: "shared_workspaces", i18n: "general_workspaces" }] : []),
                ...(clusters_for_page?.clusters_for_shared_namespaces_page?.length ? [{ key: "shared_namespaces", i18n: "namespaces" }] : []),
                ...(clusters_for_page?.clusters_for_shared_namespaces_page?.length ? [{ key: "shared_workloads", i18n: "workloads" }] : []),
                ...((permissions.monitor as permission_in_roles_number)[user_info.role] || 0 ? [{ key: "monitor", i18n: "monitor" }] : []),
              ],
            },
            {
              key: formatMessage({ id: "infrastructure" }),
              sub: [
                ...(((permissions.nodes as permission_in_roles_array)[user_info.role] || new Int32Array())[3] ? [{ key: "nodes", i18n: "nodes" }] : []),
                // { key: 'storages' },
                ...((((permissions.storage as permission_in_roles_array)[user_info.role] || new Int32Array())[3] ||
                  ((permissions.pvc as permission_in_roles_array)[user_info.role] || new Int32Array())[3] ||
                  ((permissions.pv as permission_in_roles_array)[user_info.role] || new Int32Array())[3])
                  ? [{ key: 'persistent_volume', i18n: 'persistent_volume', }]
                  : []),
                ...(((permissions.workspacequotas as permission_in_roles_array)[user_info.role] || new Int32Array())[3] ||
                  ((permissions.namespacequotas as permission_in_roles_array)[user_info.role] || new Int32Array())[3]
                  ? [{ key: "quotas", i18n: "quotas" }]
                  : []),
                // { key: 'route' },
                // { key: 'security' }
              ],
            },
            {
              key: formatMessage({ id: "user" }),
              sub: [
                ...(((permissions.user_management as permission_in_roles_array)[user_info.role] || new Int32Array())[3]
                  ? [{ key: "resource_permissions", i18n: "resource_permissions" }]
                  : []),
                ...(user_info.is_namespacedeveloper
                ? []
                : [{ key: "batch_add", i18n: "batch_add" }]),
                ...(user_info.is_namespacedeveloper
                ? []
                : [{ key: "batch_delete", i18n: "batch_delete" }]),
              ],
            },
            {
              key: formatMessage({ id: "router_management" }),
              sub: [
                ...(((permissions.ingress as permission_in_roles_array)[user_info.role] || new Int32Array())[5] ? [{ key: "ingress", i18n: "ingress" }] : []),
              ],
            },
            ...(user_info.is_namespacedeveloper
              ? []
              : [{
                key: formatMessage({ id: "system_settings" }),
                sub: [
                  ...([{ key: "records", i18n: "operation_records" }]),
                ],
              }]),
            {
              key: formatMessage({ id: "events" }),
              sub: [
                ...([{ key: "pod_restart_alarm", i18n: "pod_restart_alarm" }]),
              ],
            },
            {
              key: formatMessage({ id: "service_instance" }),
              sub: [
                { key: "list_instance", i18n: "instance_list" },
                ...(user_info.ssoRole === 'globalAdmin' ? [{ key: "management_resource", i18n: "resource_management" }] : []),
                ...((Version.mp_cloud as any === 'true'? user_info.ssoRole === 'globalAdmin': true)? [{
                  key: "storage-settings",
                  i18n: 'storage_settings'
                }, {
                  key: "service-backup-scheduler",
                  i18n: 'backup_scheduler'
                }]: [])
              ],
            }
          ]
          : [
            { key: "applications", i18n: "applications" },
            {
              key: formatMessage({ id: "platform-management" }),
              sub: [
                { key: "monitor", i18n: "monitor" },
              ],
            },
            {
              key: formatMessage({ id: "service_instance" }),
              sub: [
                { key: "list_instance", i18n: "instance_list" },
                ...(user_info.ssoRole === 'globalAdmin' ? [{ key: "management_resource", i18n: "resource_management" }] : []),
                ...((Version.mp_cloud as any === 'true'? user_info.ssoRole === 'globalAdmin': true) ?[{
                  key: "storage-settings",
                  i18n: 'storage_settings'
                }, {
                  key: "service-backup-scheduler",
                  i18n: 'backup_scheduler'
                }]: [])
              ],
            },
          ],
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [formatMessage, user_info.role, clusters_for_page, is_ssoSubscriptions, user_info.ssoRole, user_info.is_globaladmin, user_info.is_datacenteradmin, user_info.ssoSubscriptions, user_info.is_namespacedeveloper]
    ),
    left_menu: JSX.Element[] = useMemo((): JSX.Element[] => {
      const left_menu: JSX.Element[] = [],
        links: link = {
          workspaces: "cluster-info/workspaces",
          namespaces: "workspace-info/namespaces",
          workloads: "namespace-info/workloads",
          monitor: "monitor/kubernetes",
          quotas: `quotas/${user_info.role !== "namespaceDeveloper" ? "work" : "name"}space-quotas`,
          groups: `user/groups`,
          permissions: `user/management`,
          ingress: `ingress-info/ingress`,
          workload: "application/workload",
          instance: "instance-list",
          resource: "resource/view",
          add: "user/addusers-profile",
          delete: "user/deleteusers-profile",
          restart_alarm: "restart-alarm",
          volume: "storage-info/storage",
        };

      let item: left_menu_item_global, key: string;

      for (let i = 0; i < global_items.length; i++) {
        item = global_items[i];
        key = item.key;
        const sub: JSX.Element[] = [];
        let item_sub_key: string, item_sub_true_key: string;
        if (item.sub) {
          for (let j = 0; j < item.sub.length; j++) {
            item_sub_key = item.sub[j].key.indexOf("_") > -1 ? item.sub[j].key.slice(item.sub[j].key.indexOf("_") + 1) : item.sub[j].key;
            item_sub_true_key = item.sub[j].key;
            sub.push(
              <Menu.Item key={item_sub_true_key} {...item_sub_true_key === "batch_add" || item_sub_true_key === "batch_delete" ? {onClick: () => {set_show_guide(false); set_close_guide(false)}} : {}}>
                <Link to={`/${links[item_sub_key] || item_sub_key}`}>
                  {/* {key_to_title(item_sub_key)} */}
                  {/* 替换 */}
                  <FormattedMessage id={item.sub[j].i18n}></FormattedMessage>
                </Link>
              </Menu.Item>
            );
          }
        }

        const title: JSX.Element = (
          <Fragment>
            {/* {key_to_title(key)} */}
            {key}
          </Fragment>
        );

        if (user_info) {
          if (i === 0) {
            left_menu.push(
              <Menu.Item key="applications" >
                <Link to="/applications" className="font_14">
                  <FormattedMessage id="applications"></FormattedMessage>
                </Link>
              </Menu.Item>
            )
          } else if (i === 1) {
            let sub_dedicate =
              Array.isArray(sub) &&
              sub.filter(
                (item) =>
                  item.key === "dedicate_clusters" ||
                  item.key === "dedicate_workspaces" ||
                  item.key === "dedicate_namespaces" ||
                  item.key === "dedicate_workloads"
              );
            let sub_shared =
              Array.isArray(sub) &&
              sub.filter(
                (item) =>
                  item.key === "shared_clusters" || item.key === "shared_workspaces" || item.key === "shared_namespaces" || item.key === "shared_workloads"
              );

            // 后面可能需要
            let sub_else = Array.isArray(sub) && sub.filter((item) => !(item.key as string).includes("dedicate") && !(item.key as string).includes("shared"));

            left_menu.push(
              <SubMenu key={key} title={title}>
                {(clusters_for_page?.clusters_for_dedicate_clusters_page?.length ||
                  clusters_for_page?.clusters_for_dedicate_workspaces_page?.length ||
                  clusters_for_page?.clusters_for_dedicate_namespaces_page?.length) && (
                    // <SubMenu key="dedicate" title={[<RightCircleFilled key="1" style={{ fontSize: 12 }} />, formatMessage({ id: "dedicate_cluster" })]}>
                    <SubMenu key="dedicate" title={[formatMessage({ id: "dedicate_cluster" })]}>
                      {sub_dedicate}
                    </SubMenu>
                  )}
                {(clusters_for_page?.clusters_for_shared_clusters_page?.length ||
                  clusters_for_page?.clusters_for_shared_workspaces_page?.length ||
                  clusters_for_page?.clusters_for_shared_namespaces_page?.length) && (
                    // <SubMenu key="shared" title={[<RightCircleFilled key="1" style={{ fontSize: 12 }} />, formatMessage({ id: "shared_cluster" })]}>
                    <SubMenu key="shared" title={[formatMessage({ id: "shared_cluster" })]}>
                      {sub_shared}
                    </SubMenu>
                  )}
                {sub_else}
                {/* {user_info.role ? <Menu.Item key="monitor" onClick={() => { set_show_guide(false); set_close_guide(false) }}>
                  <Link to="/monitor/kubernetes" className="font_14">
                    <FormattedMessage id="monitor"></FormattedMessage>
                  </Link>
                </Menu.Item> : <Menu.Item key="monitor" onClick={() => { set_show_guide(false); set_close_guide(false) }}>
                  <Link to="/monitor/service-usage" className="font_14">
                    <FormattedMessage id="monitor"></FormattedMessage>
                  </Link>
                </Menu.Item>} */}
              </SubMenu>
            );
          } else {
            left_menu.push(
              <SubMenu key={key} title={title} data-tut={key === formatMessage({ id: 'events' }) && "reactour_step1"}>
                {sub}
              </SubMenu>
            );
          }
        }
        // }
      }
      return left_menu;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [global_items, user_info, clusters_for_page, formatMessage, is_ssoSubscriptions, user_info.ssoRole, user_info.role]),
    on_select = useCallback((param: any) => {
      sessionStorage.setItem("sidebarKey", param.selectedKeys[0]);
    }, []),

    onOpenChange = useCallback((keys: any) =>{
      const latestOpenKey = keys.find((key: any) => openKeys.indexOf(key) === -1);
      if (!(global_items.find((each: any) => each.key === latestOpenKey))) {
        setOpenKeys(keys);
      } else {
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
      }
    },[global_items, openKeys]),

    on_click = useCallback(
      (param: any) => {
        const type_name_new: string = param.key.indexOf("_") > -1 ? param.key.slice(0, param.key.indexOf("_")) : "";
        set_type_name(type_name_new);
        sessionStorage.setItem("cluster_type", type_name_new);
      },
      [set_type_name]
    );

  useEffect((): void => {
    user_info?.ssoSubscriptions && user_info?.ssoSubscriptions?.length > 0 && user_info?.ssoSubscriptions.filter((sso_subscription: user_subscription) => sso_subscription.subscriptionId === user_info?.subscription_id
    ).length > 0 ? set_is_ssoSubscriptions(true) : set_is_ssoSubscriptions(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info?.ssoSubscriptions, user_info?.subscription_id])

  // useEffect((): void => {
  //   (async (): Promise<void> => {
  //     const version_new: string | undefined = ((await http_request("version", props, undefined, "/v1/version", 0, "globalAdmin", undefined, "", "")) as {
  //       version?: string;
  //     })?.version;
  //     version_new && set_version(version_new);
  //   })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect((): void => {
    switch (path) {
      case "clusters":
      case "cluster-info/overview":
        type_name === "dedicate"
          ? sessionStorage.setItem("sidebarKey", "dedicate_clusters")
          : type_name === "shared" && sessionStorage.setItem("sidebarKey", "shared_clusters");
          setOpenKeys([formatMessage({ id: "platform-management" }), type_name]);
        break;
      case "cluster-info/workspaces":
      case "workspace-info/overview":
        type_name === "dedicate"
          ? sessionStorage.setItem("sidebarKey", "dedicate_workspaces")
          : type_name === "shared" && sessionStorage.setItem("sidebarKey", "shared_workspaces");
          setOpenKeys([formatMessage({ id: "platform-management" }), type_name]);
        break;
      case "workspace-info/namespaces":
      case "namespace-info/overview":
        type_name === "dedicate"
          ? sessionStorage.setItem("sidebarKey", "dedicate_namespaces")
          : type_name === "shared" && sessionStorage.setItem("sidebarKey", "shared_namespaces");
          setOpenKeys([formatMessage({ id: "platform-management" }), type_name]);
        break;
      case "namespace-info/workloads":
        type_name === "dedicate"
          ? sessionStorage.setItem("sidebarKey", "dedicate_workloads")
          : type_name === "shared" && sessionStorage.setItem("sidebarKey", "shared_workloads");
        break;
      case "monitor":
      case "monitor/kubernetes":
      case "monitor/overview":
      case "monitor/service-usage":
        sessionStorage.setItem("sidebarKey", "monitor");
        setOpenKeys([formatMessage({ id: "platform-management" })]);
        break;
      case "applications":
      case "nodes":
        sessionStorage.setItem("sidebarKey", path);
        break;
      case "applications-detail":
        sessionStorage.setItem("sidebarKey", "applications");
        break;
      case "storage-info/storage":
      case "storage-info/pvc":
      case "storage-info/pv":
        sessionStorage.setItem("sidebarKey", "persistent_volume");
        break;
      case "quotas/workspace-quotas":
      case "quotas/namespace-quotas":
        sessionStorage.setItem("sidebarKey", "quotas");
        break;
      case "user/management":
        sessionStorage.setItem("sidebarKey", "resource_permissions");
        break;
      case "ingress-info/ingress":
        sessionStorage.setItem("sidebarKey", "ingress");
        break;
      case "instance-list":
        sessionStorage.setItem("sidebarKey", "list_instance");
        setOpenKeys([formatMessage({ id: "service_instance" })]);
        break;
      case "create-secret":
        sessionStorage.setItem("sidebarKey", "list_instance");
        break;
      case "resource/view":
      case "resource/service":
        sessionStorage.setItem("sidebarKey", "management_resource");
        break;
      case "console":
        sessionStorage.removeItem("sidebarKey");
        setOpenKeys([]);
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [path, type_name, set_fly_in]);

  useEffect(() => {
    const pathname_arr: string[] = service_pathname.filter((val: string) => val.includes(path));
    (pathname_arr.length <= 0) && close_loading();
    if (path.includes("login")) {
      set_fly_in(undefined)
    }
    // eslint-disable-next-line
  }, [path]);

  // useEffect(() => {
  //   show_guide && set_fly_in(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [show_guide])

  return (
    <div id="left-menu" className={`mp_left_sidebar d-flex flex-column management ${fly_in ? " fly_in" : ""}`} onClick={prevent} onMouseLeave={() => close_guide ? set_fly_in(1) : set_fly_in(undefined)}>
      <div className="flex_grow">
        <Menu
          mode="inline"
          theme='light'
          inlineIndent={26}
          selectedKeys={[sessionStorage.getItem("sidebarKey") as string]}
          onSelect={on_select}
          onClick={on_click}
          // openKeys={ close_guide ? [formatMessage({ id: "events" })] : openKeys}
          onOpenChange={onOpenChange}
          // {...show_service_key ? { openKeys: [formatMessage({ id: "service_instance" })] } : {}}
          // {...close_guide ? { openKeys: [formatMessage({ id: "user" })] } : {}}
        >
          {left_menu}
        </Menu>
        {/* {show_guide && <Guidance />} */}
      </div>
      <Row className="sider_version">
        <Col className="version">UI {formatMessage({ id: "version" })}</Col>
        <Col sm={15}>: V {Version.version_ui}</Col>
      </Row>
      {/* <Row className="sider_version">
        <Col className="version">API {formatMessage({ id: "version" })}</Col>
        <Col sm={15}>: V {version}</Col>
      </Row> */}
    </div>
  );
};

export default injectIntl(withRouter(LeftMenu) as any);
